import { Lightning } from "@lightningjs/sdk";
import { GlassSurface } from "../base/GlassSurface";
import { WatchButton } from "./WatchButton";
import { WATCH_GLASS, WATCH_DARK, WATCH_GOLD, watchAsset, watchText, } from "./styles";
import { PSG_PLAYERS, MARSEILLE_PLAYERS } from "./lineups";
export class TeamRoster extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._teamIndex = 0;
        this._selectedTeamIndex = 0;
    }
    static _players(players) {
        return players.map((player) => ({
            x: player.x,
            y: player.y,
            Portrait: {
                x: player.portraitX,
                w: player.size,
                h: player.size,
                src: watchAsset(`${player.image}.png`),
            },
            NameBackground: {
                y: player.labelY,
                w: player.width,
                h: player.labelH,
                rect: true,
                color: WATCH_GOLD,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: player.labelH / 8.5,
                },
            },
            Name: {
                y: player.labelY,
                text: Object.assign(Object.assign({}, watchText(player.name, player.font, player.width)), { h: player.labelH, lineHeight: player.labelH, textColor: WATCH_DARK }),
            },
            Number: {
                x: player.numberX,
                y: player.numberY,
                text: Object.assign(Object.assign({}, watchText(`#${player.number}`, player.numberFont, player.numberW, player.numberFace)), { h: player.numberH, lineHeight: player.numberH, textColor: 0xffffffff }),
            },
            Marker: {
                x: player.markerX,
                y: player.markerY,
                w: player.markerSize,
                h: player.markerSize,
                texture: Lightning.Tools.getSvgTexture(watchAsset("radio.svg"), Math.ceil(player.markerSize * 2), Math.ceil(player.markerSize * 2)),
            },
        }));
    }
    static _template() {
        return {
            w: 929,
            h: 682,
            Glass: {
                type: GlassSurface,
                y: 86,
                w: 929,
                h: 596,
                glassOptions: WATCH_GLASS,
            },
            Tint: {
                y: 86,
                w: 929,
                h: 596,
                rect: true,
                color: 0x33161616,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 24 },
            },
            Artwork: {
                y: 86,
                w: 929,
                h: 596,
                rtt: true,
                clipping: true,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 24 },
                Pitch: {
                    x: -7,
                    y: 128,
                    w: 944,
                    h: 531,
                    src: watchAsset("pitch.png"),
                },
                Players: {
                    children: this._players(PSG_PLAYERS),
                },
            },
            Teams: {
                x: 107.5,
                y: 0,
                w: 714,
                h: 70,
                Background: {
                    w: 714,
                    h: 70,
                    rect: true,
                    color: 0x4d161616,
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
                },
                PSG: {
                    type: WatchButton,
                    label: "PARIS SAINT GERMAIN",
                    icon: "psg",
                    selected: true,
                },
                Marseille: {
                    x: 357,
                    type: WatchButton,
                    label: "MARSEILLE",
                    icon: "marseille",
                },
            },
        };
    }
    _getFocused() {
        return this.tag(this._teamIndex ? "Teams.Marseille" : "Teams.PSG");
    }
    _handleLeft() {
        this._teamIndex = 0;
        this._refocus();
        return true;
    }
    _handleRight() {
        this._teamIndex = 1;
        this._refocus();
        return true;
    }
    _handleEnter() {
        if (this._selectedTeamIndex === this._teamIndex)
            return true;
        this._selectedTeamIndex = this._teamIndex;
        this.tag("Artwork.Players").children = TeamRoster._players(this._selectedTeamIndex ? MARSEILLE_PLAYERS : PSG_PLAYERS);
        this.tag("Teams.PSG").selected = this._selectedTeamIndex === 0;
        this.tag("Teams.Marseille").selected = this._selectedTeamIndex === 1;
        return true;
    }
}
export default TeamRoster;
//# sourceMappingURL=TeamRoster.js.map